import {useCallback} from "react";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";

import {
  MessageType,
  type SignalRMessage,
} from "../../../services/signalR/models/Messages";
import type MessageHandler from "../types/MessageHandler";
import IsaacToast from "../../isaacToast/IsaacToast";
import useCalculationCompleteHandler from "./useCalculationCompleteHandler";
import useDefaultHandler from "./useDefaultHandler";
// TODO : Move this slice to a better location
import {markAsRead} from "../../../pages/layout/messagesSlice";

const useMessageHandle = (): ((message: SignalRMessage) => void) => {
  const dispatch = useDispatch();
  const calculationCompleteHandler = useCalculationCompleteHandler();
  const defaultHandler = useDefaultHandler();

  const handleMessage = useCallback((message: SignalRMessage): void => {
    const messageHandlers: MessageHandler = {
      [MessageType.CalculationCompleted]: calculationCompleteHandler,
      default: defaultHandler,
    };

    if (!message.success) {
      // Note: exclude tsx code from hook.
  

      const extraInfo = message.data
        ? new Map<string, string>([
            ["Construction ID", message.data?.constructionId ?? ""],
            ["Calculation ID", message.data?.calculationId ?? ""],
          ])
        : undefined;
      toast(
        <IsaacToast
          message="Server side error occurred!"
          toastType="error"
          source={message.source}
          additionalMessage={message.message ?? ""}
          correlationId={message.correlationId}
          traceId={message.traceId}
          statusCode={message.statusCode}
          extraInfo={extraInfo}
        />,
        {
          toastId: message.data?.constructionId,
          isLoading: false,
          autoClose: false,
          type: "error",
          closeButton: true,
        },
      );
      return;
    }

    if (!message.data){
      messageHandlers.default(message);
      return;
    }

    const handler = messageHandlers[message.type] ?? messageHandlers.default;
    handler(message);
    dispatch(markAsRead(message.id ?? ""));
  }, [calculationCompleteHandler, defaultHandler, dispatch]);

  return handleMessage;
};

export default useMessageHandle;
